export const DATA_NATIONAL = 'm_nationality';
export const DATA_RELIGION = 'm_religion';
